<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar dark flat>
            <v-toolbar-title>Parceiro</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Usuário"
                name="usuario"
                v-model="user.username"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>

              <v-text-field
                label="Senha"
                name="senha"
                v-model="user.password"
                prepend-icon="mdi-lock"
                type="password"
                v-on:keyup.enter="login()"
              ></v-text-field>
            </v-form>
            <v-alert type="error" v-if="error">Dados incorretos, tente novamente!</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="login()" color="secondary">Entrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import router from "../router/index.js";
export default {
  data: () => ({
    error: false,
    user: {
      username: "",
      secret: ""
    }
  }),
  created: function(){
    var token = localStorage.getItem("token");
    if(token){
      router.push("/home");
    }
  },
  methods: {
    login: function() {
      var me = this;
      this.$auth
        .login(me.user)
        .then(function() {
          router.push("/home");
        })
        .catch(function() {
          me.error = true;
        });
    }
  }
};
</script>